"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkDownloadStatus = void 0;
var BulkDownloadStatus;
(function (BulkDownloadStatus) {
    BulkDownloadStatus["Fake"] = "FAKE";
    BulkDownloadStatus["Started"] = "STARTED";
    BulkDownloadStatus["Pending"] = "PENDING";
    BulkDownloadStatus["Progress"] = "PROGRESS";
    BulkDownloadStatus["Success"] = "SUCCESS";
    BulkDownloadStatus["Failure"] = "FAILURE";
    BulkDownloadStatus["Revoked"] = "REVOKED";
})(BulkDownloadStatus = exports.BulkDownloadStatus || (exports.BulkDownloadStatus = {}));
//# sourceMappingURL=enums.js.map